import React from 'react';
import styles from './titles.module.scss';
import classNames from 'classnames';

const SectionTitle = ({ title = '', wrapperClassName }) => (
  <div className={classNames(styles.sectionTitleContainer, wrapperClassName)}>
    <h2>{title}</h2>
  </div>
);

export { SectionTitle };
